<template>
  <div class="warpper">
    <div class="salesCountdownBar-span">
      <span class="salesCountdownBar-span-text">{{ day }}</span>
    </div>
    <div class="salesCountdownBar-div">天</div>
    <div class="salesCountdownBar-span">
      <span class="salesCountdownBar-span-text digit">{{ h1 }}</span>
      <span class="salesCountdownBar-span-text digit">{{ h2 }}</span>
      <span class="salesCountdownBar-span-text colon">:</span>
      <span class="salesCountdownBar-span-text digit">{{ m1 }}</span>
      <span class="salesCountdownBar-span-text digit">{{ m2 }}</span>
      <span class="salesCountdownBar-span-text colon">:</span>
      <span class="salesCountdownBar-span-text digit">{{ s1 }}</span>
      <span class="salesCountdownBar-span-text digit">{{ s2 }}</span>
    </div>
  </div>

</template>

<script>
export default {
  name: 'uCountDown',
  props: {
    timestamp: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      day: 0,
      timer: null,
      hours: '00',
      minutes: '00',
      secs: '00',
      h1: '0',
      h2: '0',
      m1: '0',
      m2: '0',
      s1: '0',
      s2: '0',
      time: 0,
      endTime: 0,   // 倒计时结束时刻（毫秒时间戳）
      ended: false, // 是否已结束（防止重复 emit）
    }
  },

  watch: {
    timestamp: {
      handler(val) {
        if (val > 0) {
          this.initTimer();
        } else {
          this.stopTimer();
        }
      },
      immediate: true
    }
  },

  activated() {
    // keep-alive 缓存重新激活：若未结束，按剩余时间精确恢复
    if (this.endTime > 0 && !this.ended) {
      this.initTimerByEndTime();
    }
  },

  deactivated() {
    // keep-alive 缓存：停止倒计时，避免后台归零误触发 countDownEnd
    this.stopTimer();
  },

  beforeDestroy() {
    this.stopTimer();
  },

  methods: {
    // 启动倒计时
    initTimer() {
      const ts = this.timestamp;
      if (ts <= 0) return;
      this.ended = false;
      this.endTime = Date.now() + ts * 1000; // 记录结束时刻
      this.initTimerByEndTime();
    },

    // 基于 endTime 启动/恢复定时器
    initTimerByEndTime() {
      this.stopTimer();
      this.renderRemaining();
      this.timer = setInterval(() => {
        this.renderRemaining();
      }, 1000);
    },

    // 停止倒计时
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    // 根据 endTime 计算剩余秒数并渲染
    renderRemaining() {
      const remaining = Math.max(0, Math.ceil((this.endTime - Date.now()) / 1000));
      this.day = Math.floor(remaining / 86400);
      this.time = remaining % 86400;
      this.renderTime();
      if (remaining <= 0 && !this.ended) {
        this.ended = true;
        this.stopTimer();
        this.$emit('countDownEnd');
      }
    },

    // 根据 this.time 刷新展示
    renderTime() {
      const hours = Math.floor(this.time / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((this.time % 3600) / 60).toString().padStart(2, '0');
      const secs = (this.time % 60).toString().padStart(2, '0');
      this.hours = hours;
      this.minutes = minutes;
      this.secs = secs;
      this.h1 = hours[0]; this.h2 = hours[1];
      this.m1 = minutes[0]; this.m2 = minutes[1];
      this.s1 = secs[0]; this.s2 = secs[1];
    },
  }

}
</script>

<style lang="less" scoped>
.warpper {
  display: flex;
  align-items: center;
  gap: 0 4px;
}

.salesCountdownBar-div {
  font-size: 18px;
  height: 22px;
  line-height: 22px;
  color: #fff;
}

.salesCountdownBar-span {
  display: flex;
  justify-content: center;
  padding: 1px 2px;
  border-radius: 3px;
  background-color: #fff;

}

.salesCountdownBar-span-text {
  color: #FA531F;
  font-size: 19px;
  line-height: 1;
}

.salesCountdownBar-span-text.digit {
  display: inline-block;
  width: 12px;
  text-align: center;
}

.salesCountdownBar-span-text.colon {
  margin: 0 1px;
}
</style>
